import { CONSTANTS } from '@sohohouse/platform-resources'
import designTokens from '@sohohouse/design-system/dist/tokens/tokens.json'

const {
  color_status_green: green,
  color_status_light_green: lightGreen,
  color_status_gray: gray,
  color_status_pink: pink,
  color_status_red: red,
  color_status_orange: orange,
  color_status_yellow: yellow
} = designTokens

export const EVENT_STATUSES = {
  [CONSTANTS.EVENT_STATUSES.WAITING_LIST]: {
    code: CONSTANTS.EVENT_STATUSES.WAITING_LIST,
    label: 'EXPLORE_EVENTS_EVENT_WAITING_LABEL',
    colour: yellow
  },
  [CONSTANTS.EVENT_STATUSES.FULLY_BOOKED]: {
    code: CONSTANTS.EVENT_STATUSES.FULLY_BOOKED,
    label: 'EXPLORE_EVENTS_EVENT_BOOKED_LABEL',
    colour: red
  },
  [CONSTANTS.EVENT_STATUSES.EVENT_CLOSED]: {
    code: CONSTANTS.EVENT_STATUSES.EVENT_CLOSED,
    label: 'EXPLORE_EVENTS_EVENT_CLOSED_LABEL',
    colour: pink
  },
  [CONSTANTS.EVENT_STATUSES.BOOKING_OPENS_DATE]: {
    code: CONSTANTS.EVENT_STATUSES.BOOKING_OPENS_DATE,
    label: 'EXPLORE_EVENTS_EVENT_OPENS_LABEL',
    colour: lightGreen
  },
  [CONSTANTS.EVENT_STATUSES.EVENT_PAST]: {
    code: CONSTANTS.EVENT_STATUSES.EVENT_PAST,
    label: 'EXPLORE_EVENTS_EVENT_PAST_LABEL',
    colour: gray
  },
  [CONSTANTS.EVENT_STATUSES.HOUSE_MEMBER_ONLY]: {
    code: CONSTANTS.EVENT_STATUSES.HOUSE_MEMBER_ONLY,
    label: 'EXPLORE_EVENTS_EVENT_MEMBERS_ONLY_LABEL',
    colour: gray
  },
  [CONSTANTS.EVENT_STATUSES.EVENT_POSTPONED]: {
    code: CONSTANTS.EVENT_STATUSES.EVENT_POSTPONED,
    label: 'EXPLORE_EVENTS_EVENT_POSTPONED_LABEL',
    colour: orange
  },
  [CONSTANTS.EVENT_STATUSES.OPEN_FOR_BOOKING]: {
    code: CONSTANTS.EVENT_STATUSES.OPEN_FOR_BOOKING,
    label: null,
    colour: null
  },
  [CONSTANTS.EVENT_STATUSES.LOTTERY_OPEN]: {
    code: CONSTANTS.EVENT_STATUSES.LOTTERY_OPEN,
    label: null,
    colour: null
  },
  [CONSTANTS.EVENT_STATUSES.HAPPENING_NOW]: {
    code: CONSTANTS.EVENT_STATUSES.HAPPENING_NOW,
    label: null,
    colour: red
  }
}

export const EVENT_BOOKING_STATUSES = {
  [CONSTANTS.EVENT_BOOKING_STATUSES.HELD]: {
    code: CONSTANTS.EVENT_BOOKING_STATUSES.HELD,
    label: 'EXPLORE_EVENTS_EVENT_CHECKING_CARD_LABEL',
    colour: yellow
  },
  [CONSTANTS.EVENT_BOOKING_STATUSES.ON_WAITING_LIST]: {
    code: CONSTANTS.EVENT_BOOKING_STATUSES.ON_WAITING_LIST,
    label: 'EXPLORE_EVENTS_EVENT_WAITING_CARD_LABEL',
    colour: yellow
  },
  [CONSTANTS.EVENT_BOOKING_STATUSES.CONFIRMED]: {
    code: CONSTANTS.EVENT_BOOKING_STATUSES.CONFIRMED,
    label: 'EXPLORE_EVENTS_EVENT_GOING_LABEL',
    colour: green
  },
  [CONSTANTS.EVENT_BOOKING_STATUSES.IN_LOTTERY]: {
    code: CONSTANTS.EVENT_BOOKING_STATUSES.IN_LOTTERY,
    label: 'EXPLORE_CINEMA_EVENT_CONFIRMATION_PENDING_LABEL',
    colour: green
  }
}
